'use client'

import React from 'react'
import { Section } from '@/components/Section'
import { Heading } from '@/components/ui/heading'
import { Text } from '@/components/ui/text'
import { RoadmapBlock } from '@/payload-types'
import RichText from '@/components/RichText'
import { Subheading } from '@/components/ui/subheading'
import { Label } from '@/components/ui/label'

export function RoadmapClient({
  updatedAt,
  projects,
}: {
  updatedAt?: RoadmapBlock['updatedAt']
  projects?: RoadmapBlock['projects']
}) {
  return (
    <Section bgClassName="bg-rock-1">
      <div className="container mx-auto">
        {/* Header */}
        <div className="flex flex-col gap-[40px] pb-[40px]">
          <Heading size="h2" className="text-dark">
            What we’re working on
          </Heading>
          {updatedAt && (
            <Text size="lg" className="text-dark italic">
              Last updated:{' '}
              {Intl.DateTimeFormat('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              }).format(new Date(updatedAt))}
            </Text>
          )}
        </div>

        {/* Projects */}
        <div className="space-y-6">
          {projects?.map((project, index) => (
            <div key={index} className="bg-paper-1 p-[40px]">
              {/* Project Title */}
              <div className="">
                <Heading size="h4" className="text-dark mb-6">
                  {project.heading}
                </Heading>

                {/* Two-column layout for description and objectives */}
                <div className="flex flex-col lg:flex-row gap-8">
                  <div className="lg:w-2/3">
                    {project.content && (
                      <RichText data={project.content} className="prose-info prose-dark" />
                    )}
                  </div>

                  {/* Objectives Column */}
                  <div className="lg:w-1/3">
                    <Subheading size="md">Objectives</Subheading>
                    <div className="space-y-[15px] pt-[30px]">
                      {project.objectives?.map((objective, i) => (
                        <div key={i}>
                          <div className="inline-block px-[15px] py-[4px] bg-paper-4">
                            <Label className="uppercase">{objective.title}</Label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  )
}
